import React from 'react';
import { Card, Col, Row, Table, Spinner } from 'react-bootstrap';
import GenerateInvoicesButton from '../Components/Buttons/GenerateInvoicesButton';
import { withAuthenticationRequired } from '../providers/withAuthenticationRequired';
import { useTicketsWaitingForInvoicingQuery } from '../queries/invoicing.query';

function InvoicingPage() {
  const { data, isLoading, isError } = useTicketsWaitingForInvoicingQuery();

  const formatCurrency = (amount: number | null) => {
    if (amount === null || amount === undefined) return '-';
    return `$${amount.toFixed(2)}`;
  };

  return (
    <div className="mt-4">
      <Row className="mb-4 align-items-center">
        <Col>
          <h2 className="mb-0">Invoice Generation</h2>
        </Col>
        <Col xs="auto">
          <GenerateInvoicesButton />
        </Col>
      </Row>

      {isLoading ? (
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : isError ? (
        <div className="text-center py-5">
          <p className="text-danger">Failed to load tickets waiting for invoicing.</p>
        </div>
      ) : (
        <>
          <Row className="mb-4">
            <Col md={6}>
              <Card className="text-center h-100">
                <Card.Body>
                  <Card.Title className="text-muted">Total</Card.Title>
                  <h2 className="mb-0">{data?.totalCount ?? 0}</h2>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="text-center h-100">
                <Card.Body>
                  <Card.Title className="text-muted">Guilty</Card.Title>
                  <h2 className="mb-0 text-warning">{data?.guiltyCount ?? 0}</h2>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Card>
            <Card.Header>
              <h5 className="mb-0">Tickets Waiting for Invoicing</h5>
            </Card.Header>
            <Card.Body className="p-0">
              {data?.tickets && data.tickets.length > 0 ? (
                <Table striped bordered hover responsive className="mb-0">
                  <thead>
                    <tr>
                      <th>Summons</th>
                      <th>Plate</th>
                      <th>Client</th>
                      <th>Fine</th>
                      <th>Outcome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.tickets.map((ticket) => (
                      <tr key={ticket.ticketId}>
                        <td>{ticket.summonsNumber}</td>
                        <td>{ticket.plateNumber}</td>
                        <td>{ticket.clientName}</td>
                        <td>{formatCurrency(ticket.fineAmount)}</td>
                        <td>
                          <span
                            className={`badge ${
                              ticket.isDismissed ? 'bg-success' : 'bg-warning text-dark'
                            }`}>
                            {ticket.isDismissed ? 'Dismissed' : 'Guilty'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted mb-0">No tickets waiting for invoicing.</p>
                </div>
              )}
            </Card.Body>
          </Card>
        </>
      )}
    </div>
  );
}

export default withAuthenticationRequired(InvoicingPage);
